{
  "ACTIONS": {
    "CONFIRM": "Confirmar",
    "CONTINUE": "Continuar",
    "SUBMIT": "Enviar",
    "RETRY": "Reintentar",
    "CANCEL": "Cancelar",
    "EMPTY": "No tienes ningún pedido",
    "LOADING_ORDERS": "Preparando tu cuenta",
    "CLEAR_ALL": "Borrar Todo",
    "AWESOME": "Awesome!",
    "VIEW_RECEIPT": "The Receipt",
    "ADD_CART": "Add to Cart",
    "UPDATE_CART": "Actualizar carrito",
    "EDIT": "Editar",
    "SEARCH_PLACEHOLDER": "Search for food or restaurants"
  },
  "COMMON": {
    "CALORIES": "Cal. {{calories}}",
    "MISSING_SELECTIONS": "Faltan algunas opciones. Por favor, selecciona antes de continuar",
    "ITEM_UNAVAILABLE": "This item is currently not available",
    "SECTION_NOT_FOUND": "Esta sección ya no está disponible",
    "ITEM_NOT_FOUND": "Este artículo ya no está disponible",
    "PROMOTION_NOT_AVAILABLE": "Esta promoción ya no está disponible",
    "REQUIRED": "Required",
    "COMBO": "Combo",
    "INVALID_EMAIL": "Por favor, introduce un correo electrónico válido",
    "INVALID_PHONE": "Por favor, introduce un número de teléfono válido",
    "FEES": "Fees",
    "MIN_ORDER_ERROR": "Minimum order value of {{currency}} {{amount}} is required to place your order",
    "ADD_MIN_ORDER": "Add {{currency}} {{amount}} to place your order",
    "CONNECTION_ERROR": "Algo salió mal al cargar esta mesa. Por favor, inténtalo de nuevo.",
    "TABLE_NOT_FOUND": "No pudimos encontrar esta mesa. Por favor, vuelve a escanear el código QR."
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربى",
    "FA": "فارسی",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Apellido",
    "ROOM_NUMBER": "Número de Habitación",
    "SNACKBAR_TITLE": "Tu cuenta está en camino",
    "PAY_BILL": "Pagar la cuenta"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "Total de personas en la mesa",
    "PAYING_FOR": "Total de personas por las que pagas",
    "REMAINING": "Importe restante",
    "CHEQUE": "Cuenta",
    "AMOUNT_PAID": "Importe pagado",
    "DISCOUNT": "Descuento",
    "PROMO": "Promo",
    "FEES": "Cargos",
    "PAID_ITEMS": "Artículos pagados",
    "SPLIT_BILL": "Dividir la cuenta",
    "EDIT_SPLIT": "Editar división",
    "PAY_BILL": "Pagar la cuenta",
    "SPLIT_TITLE": "Dividir la cuenta",
    "SPLIT_SUBTITLE": "Selecciona cómo quieres dividir la cuenta",
    "SPLIT_EVENLY": "Dividir en partes iguales",
    "CUSTOM_AMOUNT": "Importe personalizado",
    "ADD_CUSTOM_AMOUNT": "Añadir importe personalizado",
    "CUSTOM_AMOUNT_PLACEHOLDER": "Introduce un importe personalizado",
    "PAY_FOR_ITEMS": "Paga tus artículos",
    "CONFIRM_SELECTION": "Confirmar selección",
    "SOMEONE_ELSE_PAYING": "Otra persona de tu mesa está pagando ahora mismo"
  },
  "COMBO": {
    "ADD_N": "Añadir {{count}} {{section}}",
    "REMOVE_N": "Quitar {{count}} {{section}}",
    "CANNOT_PROCEED": "Por favor, sigue la guía de arriba para completar tu combo antes de continuar",
    "COMPLETE": "¡Combo {{combo}} completo!",
    "ON_ANOTHER_SECTION": "Esto es parte de tu combo de {{section}}"
  },
  "CART": {
    "TITLE": "Carrito",
    "RECOMMENDATION": "También te puede gustar",
    "TOTAL": "Total",
    "VIEW": "Ver carrito & Hacer pedido",
    "EMPTY": "Vacío",
    "PLACE_ORDER": "Hacer pedido",
    "ADD_TO_BILL": "Añadir a la cuenta",
    "PAY_NOW": "Pagar ahora",
    "OOPS": "Oops",
    "ADD_NEW_VARIANT": "Añadir otro",
    "VARIANT_TITLE": "¿Cambiaste de opinión?",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Are you sure you want to clear the cart?",
    "CLEAR": "Clear Cart",
    "ADD_NOTE": "ADD A NOTE",
    "NOTE_LABEL": "Note"
  },
  "PAYMENT": {
    "CONFIRMED": "¡Tu pedido ha sido procesado!",
    "ERROR": "Se ha producido un error durante el pago. Por favor, inténtalo de nuevo",
    "APPLE_PAY_TAP_AGAIN": "Por favor, pulsa Apple Pay de nuevo para continuar",
    "TITLE": "Pago",
    "PAY_CARD": "Pago",
    "SUCCESSFUL": "Payment Was Successful",
    "SUMMARY": "Payment Summary",
    "PROGRESS": "Payment in progress..., please wait",
    "CANCEL": "Please do not refresh this page or click on the back button. If you wish to cancel, please press the cancel button on the payment machine."
  },
  "ORDER": {
    "TITLE": "Mis pedidos",
    "CONFIRMED": "Confirmado",
    "NOTES": "Order Notes",
    "TOTAL": "Total",
    "SUBTOTAL": "Subtotal",
    "ORDER": "Pedido",
    "PAID": "Pagado",
    "PLACED": "Your Order Has Been Placed",
    "UNPAID": "Tu pedido no está pagado",
    "CANCELLED": "Tu pedido ha sido cancelado",
    "VOID": "Tu pedido ha sido anulado",
    "UPDATED": "Tu pedido ha sido actualizado",
    "ORDERS": "Orders",
    "PREVIOUS": "Previous Orders",
    "REJECTED": "Oops! One or more items or modifiers are currently unavailable and have been removed from your cart."
  },
  "WAITER": {
    "SNACKBAR_TITLE": "Estaremos contigo en breve",
    "HELP": "¿Cómo podemos ayudar?",
    "ADDITIONAL_COMMENTS": "Comentarios"
  },
  "MENU": {
    "SKIP": "Omitir",
    "MENU": "Menú",
    "SEARCH": "Buscar",
    "NO_SEARCH_RESULTS": "No hay artículos que coincidan con tu búsqueda",
    "SEARCH_OTHER_SECTIONS": "Encontramos coincidencias en otras secciones",
    "NO_FILTER_RESULTS": "Ningún artículo coincide con tus filtros",
    "CLEAR_FILTERS": "Borrar filtros",
    "NO_SECTIONS": "No hay secciones disponibles",
    "STAFF": "Llamar a un empleado",
    "FILTERS": "Filtros Dietéticos"
  },
  "SETTINGS": {
    "TITLE": "Ajustes",
    "LANGUAGE": "Idioma",
    "SELECT_LANGUAGE": "Selecciona el idioma",
    "CURRENCY": "Moneda"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "Cargar a mi habitación"
  },
  "RESCAN": {
    "TITLE": "Código QR",
    "ACTION": "Por favor, vuelve a escanear el código QR para continuar tu sesión",
    "SESSION_EXPIRED": "Tu sesión ha expirado"
  },
  "PICKUP": {
    "TITLE": "Tus Datos"
  },
  "VOUCHER": {
    "ADD": "Añadir un Vale",
    "PLACEHOLDER": "Introduce tu vale",
    "VOUCHER": "Vale",
    "DISCOUNTED_AMOUNT": "Cantidad Total Después del Descuento",
    "CURRENT_BALANCE": "Saldo",
    "REMAINING_BALANCE": "Saldo Después de la Compra",
    "AMOUNT_DUE": "Importe a Pagar"
  },
  "TIP": {
    "TIP": "Propina",
    "ADD": "Añadir propina",
    "PLACEHOLDER": "Introduce el importe de la propina"
  },
  "LANDING": {
    "CALL_WAITER": "Llamar al camarero",
    "VIEW_BILL": "Ver cuenta - ",
    "LOADING_BILL": "Cargando cuenta"
  },
  "LOADER": {
    "Heading": "Procesando tu pago...",
    "Subheading": "Por favor, no cierres esta página. Estamos confirmando tu pago y te redirigiremos automáticamente.",
    "Hint": "Esto suele tardar unos segundos."
  },
  "NoVoucher": "Vale no disponible",
  "VoucherDisabled": "Este vale está desactivado",
  "VoucherExpired": "Este vale ha caducado",
  "VoucherAlreadyUsed": "Este vale ya ha sido utilizado",
  "VoucherZeroBalance": "Este vale tiene un saldo de 0",
  "VoucherUserLimitReached": "Ya has usado este vale",
  "VoucherFirstOrderOnly": "Este vale es solo para tu primer pedido",
  "VoucherNotApplicable": "Este vale no aplica a los artículos de tu pedido"
}
